import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { IconButton } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  style?: React.CSSProperties;
}

const BackButton: React.FC<BackButtonProps> = ({ style }) => {
  const navigate = useNavigate();

  return (
    <IconButton
      size="small"
      onClick={() => navigate(-1)}
      sx={{
        mr: 1,
        width: 36,
        height: 36,
        // Theme-aware so the control reads as a recessed surface in either
        // scheme; a fixed light grey renders as a white tile on dark.
        bgcolor: 'action.hover',
        borderRadius: '10px',
        '&:hover': {
          bgcolor: 'action.selected',
        },
        ...style,
      }}
    >
      <ChevronLeftIcon fontSize="medium" />
    </IconButton>
  );
};

export default BackButton;
